/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PeerComponent { 
    /**
     * Peer component id
     */
    component_id: string;
    /**
     * Peer component org id
     */
    org_id?: string;
}

